export const getProductPrice = (product, productQtyObj, listItemsPrice) => {
  const quantity = productQtyObj[product["masterSKU_s"]] || 1
  const price = listItemsPrice[product["masterSKU_s"]] || 0
  return price * quantity
}

export const getListTotalPrice = (
  productData,
  productQtyObj,
  listItemsPrice
) => {
  let totalPrice = 0
  productData?.map(product => {
    const price = listItemsPrice[product["masterSKU_s"]] ?? 0
    const quantity = productQtyObj[product["masterSKU_s"]] || 1
    totalPrice += price * quantity
  })
  return totalPrice
}
export const getColors = (product, allVariantColors = false) => {
  const colors = product?.["Color.SKU.Details_ss"]?.map(item => {
    const [name, swatch, sku, isStock, isDiscontinued, customerFacingSKU] =
      item.split("|")
    return {
      name,
      swatch,
      sku,
      isStock,
      isDiscontinued,
      customerFacingSKU,
    }
  })
  return allVariantColors
    ? colors
    : colors?.filter(color => product["masterSKU_s"] === color.sku)
}

export const getFormattedDate = currentList => {
  const dateObj = new Date(currentList?.createdAt)
  const month = dateObj?.toLocaleString("default", { month: "long" })
  const day = dateObj.getDate()
  const year = dateObj?.getFullYear()

  // Format the date as "Month Day, Year"
  const formattedDate = `${month} ${day}, ${year}`
  return formattedDate ?? ""
}

export const getLineItemsProductImage = (data, sku) => {
  let imagestmp = []
  const productVariantImages = data?.["productImages.labelWithUrl_ss"]
    ? data?.["productImages.labelWithUrl_ss"]
    : []
  let setDefaultProductImage = ""
  if (productVariantImages?.length > 0) {
    productVariantImages.find(img => {
      const imgDetails = img.split("|")
      if (sku === imgDetails[0]) {
        return (setDefaultProductImage = imgDetails[1])
      }
    })
    setDefaultProductImage
      ? imagestmp.push(setDefaultProductImage)
      : imagestmp.push("MissingImage")
  } else {
    imagestmp = ["MissingImage"]
  }
  return imagestmp
}

export const listItemQuantityChangeTypeAndValueCal = (
  qty,
  product,
  productQtyObj
) => {
  const currentQuantity = productQtyObj[product["masterSKU_s"]]
  if (currentQuantity > qty) {
    return { updatedQuantity: currentQuantity - qty, actionType: "subtract" }
  } else if (currentQuantity < qty) {
    return { updatedQuantity: qty - currentQuantity, actionType: "add" }
  } else {
    return { updatedQuantity: "", actionType: "" }
  }
}

export const checkDiscontinuedStatus = product => {
  const availableSkus = []
  const discontinuedSkus = []
  const colorDetails = getColors(product, true)

  colorDetails?.forEach(color => {
    if (color.isDiscontinued === "false") {
      availableSkus.push(color.sku)
    } else {
      discontinuedSkus.push(color.sku)
    }
  })

  return { availableSkus, discontinuedSkus }
}

export const createSharedListUrl = (list, language, listName) => {
  let skus = ""
  if (typeof list === "string") {
    skus = list
  } else {
    skus = list?.lineItems?.map(item => item?.variant?.sku).join(",")
  }
  const baseUrl = typeof window !== "undefined" ? window.location.origin : ""
  const toBase64 = str => {
    if (!str) return ""
    if (typeof window !== "undefined") {
      try {
        // handle unicode safely
        return btoa(unescape(encodeURIComponent(str)))
      } catch {
        return btoa(str)
      }
    }
    if (typeof Buffer !== "undefined") {
      return Buffer.from(str, "utf-8").toString("base64")
    }
    return ""
  }
  const encodedSkus = toBase64(skus)
  const encodedListName = toBase64(listName)
  const url = `${baseUrl}/${language}/share-list?products=${encodeURIComponent(
    encodedSkus
  )}&ListName=${encodeURIComponent(encodedListName)}`
  return url
}
